import React,{ useState, useEffect } from 'react';
import { downloadCsv } from '../common/sharedFunctions';
import MaterialTable from "material-table";
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';
import {colors} from '../components/Theme/WebTheme';
import { WEB_SECONDORY_COLOR } from "../common/sharedFunctions";
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';
import { generateWithdrawPDF, generateColombiaDispersionFile } from '../common/bankExport';
import { resolveWithdrawRowFees } from '../common/walletFees';

const Withdraws = () => {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const {
    completeWithdraw,
    rejectWithdraw,
    batchProcessWithdraws,
    fetchWithdraws
  } = api;
  const dispatch = useDispatch();
  const SECONDORY_COLOR = WEB_SECONDORY_COLOR(settings?.appCat);

  function formatAmount(value, decimal, country) {
    const number = parseFloat(value || 0);
    if (country === "Vietnam") {
      return number.toLocaleString("vi-VN", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    } else {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    }
  }

  const symbolize = (value) =>
    settings.swipe_symbol
      ? formatAmount(value, settings.decimal, settings.country) + " " + settings.symbol
      : settings.symbol + " " + formatAmount(value, settings.decimal, settings.country);

  const feeCell = (value) => (
    <span style={{ color: '#B45309', fontWeight: 600, whiteSpace: 'nowrap' }}>
      - {symbolize(value || 0)}
    </span>
  );

  const statusOf = (rowData) => {
    if (rowData.status === 'paid' || rowData.status === 'rejected') return rowData.status;
    if (rowData.processed === true || rowData.processed === 'true') return 'paid';
    return 'pending';
  };

  const statusLabel = (s) => {
    if (s === 'paid') return t('paid', { defaultValue: 'Pagado' });
    if (s === 'rejected') return t('rejected', { defaultValue: 'Rechazado' });
    return t('pending', { defaultValue: 'Pendiente' });
  };

  const statusColor = (s) => {
    if (s === 'paid') return '#06C167';
    if (s === 'rejected') return '#DF2E38';
    return '#F5A623';
  };

  const onlyPending = (rows) => (rows || []).filter(r => statusOf(r) === 'pending');

  const columns =  [
    { title: 'ID', field: 'id',editable: 'never',
  },
    { title: t('requestDate'), field: 'date', defaultSort:'desc', render: rowData => rowData.date ? moment(rowData.date).format('lll') : null,
              exportTransformer: (rowData) => new Date(rowData.date).toLocaleDateString() + ' '+ new Date(rowData.date).toLocaleTimeString()},
    { title: t('driver_name'),field: 'name',editable: 'never', 
  },
  { title: t('amount'), field: 'amount',editable: 'never',
    render: (rowData) => symbolize(rowData.amount || 0),
  },
  { title: t('withdraw_gmf', { defaultValue: '4x1000 (GMF)' }), field: 'gmf', editable: 'never',
    render: (rowData) => feeCell(resolveWithdrawRowFees(rowData, settings).gmf),
  },
  { title: t('withdraw_disbursement_fee', { defaultValue: 'Costo desembolso' }), field: 'disbursementFee', editable: 'never',
    render: (rowData) => feeCell(resolveWithdrawRowFees(rowData, settings).disbursementFee),
  },
  { title: t('withdraw_gateway_fee', { defaultValue: 'Comisión Bold (3,49% + $900)' }), field: 'gatewayFee', editable: 'never',
    render: (rowData) => feeCell(resolveWithdrawRowFees(rowData, settings).gatewayFee),
  },
  { title: t('withdraw_total_fees', { defaultValue: 'Total comisiones' }), field: 'totalFees', editable: 'never',
    render: (rowData) => feeCell(resolveWithdrawRowFees(rowData, settings).totalFees),
  },
  { title: t('withdraw_net', { defaultValue: 'Neto a transferir' }), field: 'netAmount', editable: 'never',
    render: (rowData) => (
      <span style={{ color: '#059669', fontWeight: 700, whiteSpace: 'nowrap' }}>
        {symbolize(resolveWithdrawRowFees(rowData, settings).net)}
      </span>
    ),
  },
    { title: t('status', { defaultValue: 'Estado' }), field: 'status', editable: 'never',
      render: rowData => {
        const s = statusOf(rowData);
        return (
          <span style={{
            backgroundColor: statusColor(s),
            color: '#fff',
            padding: '4px 10px',
            borderRadius: 12,
            fontSize: 12,
            fontWeight: 600,
            whiteSpace: 'nowrap'
          }}>{statusLabel(s)}</span>
        );
      }
    },
    { title: t('processDate'), field: 'processDate', render: rowData => rowData.processDate ? moment(rowData.processDate).format('lll') : null,
  },
    { title: t('document_id', { defaultValue: 'Documento' }), field: 'documentId', editable: 'never',
      render: rowData => (rowData.documentType ? rowData.documentType + ' ' : '') + (rowData.documentId || '') },
    { title: t('bankName'), field: 'bankName', hidden: settings.bank_fields===false? true: false,editable: 'never'},
    { title: t('account_type', { defaultValue: 'Tipo cuenta' }), field: 'bankAccountType', hidden: settings.bank_fields===false? true: false, editable: 'never'},
    { title: t('bankCode'), field: 'bankCode' , hidden: settings.bank_fields===false? true: false,editable: 'never'},
    { title: t('bankAccount'), field: 'bankAccount', hidden: settings.bank_fields===false? true: false,editable: 'never'}
  ];
  const [data, setData] = useState([]);
  const withdrawdata = useSelector(state => state.withdrawdata);

  useEffect(() => {
    dispatch(fetchWithdraws());
  }, [dispatch, fetchWithdraws]);

  useEffect(()=>{
        if(withdrawdata.withdraws){
            setData(withdrawdata.withdraws);
        }else{
          setData([]);
        }
  },[withdrawdata.withdraws]);

  const pending = onlyPending(data);
  const pendingFees = pending.reduce((acc, row) => {
    const f = resolveWithdrawRowFees(row, settings);
    return acc + (f.totalFees || 0);
  }, 0);
  const pendingNet = pending.reduce((acc, row) => {
    const f = resolveWithdrawRowFees(row, settings);
    return acc + (f.net || 0);
  }, 0);
  const pendingTotal = pending.reduce((acc, e) => acc + parseFloat(e.amount || 0), 0);

  const exportSelectedPDF = (rows) => {
    const items = onlyPending(rows);
    if (items.length === 0) { alert(t('no_pending_selected', { defaultValue: 'Selecciona retiros pendientes.' })); return; }
    generateWithdrawPDF(items, settings, t);
  };

  const exportSelectedBankFile = (rows) => {
    const items = onlyPending(rows);
    if (items.length === 0) { alert(t('no_pending_selected', { defaultValue: 'Selecciona retiros pendientes.' })); return; }
    generateColombiaDispersionFile(items, settings, 'bancolombia');
  };

  const markSelectedPaid = (rows) => {
    const items = onlyPending(rows);
    if (items.length === 0) { alert(t('no_pending_selected', { defaultValue: 'Selecciona retiros pendientes.' })); return; }
    if (!settings.AllowCriticalEditsAdmin) { alert(t('demo_mode')); return; }
    if (window.confirm(t('confirm_mark_paid', { defaultValue: '¿Marcar como pagados los retiros seleccionados?' }) + ' (' + items.length + ')')) {
      dispatch(batchProcessWithdraws(items)).catch((err) => {
        console.error('batchProcessWithdraws failed', err);
        alert(t('process_failed', { defaultValue: 'No se pudo procesar. Verifica tu sesión de admin e intenta de nuevo.' }));
      });
    }
  };

  return (
    withdrawdata.loading? <CircularLoading/>:
    <ThemeProvider theme={theme}>
    <div style={{
      display: 'flex', gap: 16, flexWrap: 'wrap', margin: '0 0 14px 0',
      direction: isRTL === "rtl" ? "rtl" : "ltr"
    }}>
      <div style={{ background: '#000000', color: '#fff', borderRadius: 12, padding: '14px 20px', minWidth: 200 }}>
        <div style={{ fontSize: 13, opacity: 0.8 }}>{t('pending_withdraws', { defaultValue: 'Solicitudes pendientes' })}</div>
        <div style={{ fontSize: 26, fontWeight: 700 }}>{pending.length}</div>
      </div>
      <div style={{ background: '#1a1a1a', color: '#fff', borderRadius: 12, padding: '14px 20px', minWidth: 200 }}>
        <div style={{ fontSize: 13, opacity: 0.85 }}>{t('withdraw_requested_amount', { defaultValue: 'Monto solicitado' })}</div>
        <div style={{ fontSize: 22, fontWeight: 700 }}>{symbolize(pendingTotal)}</div>
      </div>
      <div style={{ background: '#78350F', color: '#fff', borderRadius: 12, padding: '14px 20px', minWidth: 200 }}>
        <div style={{ fontSize: 13, opacity: 0.9 }}>{t('withdraw_total_fees', { defaultValue: 'Total comisiones' })}</div>
        <div style={{ fontSize: 22, fontWeight: 700 }}>{symbolize(pendingFees)}</div>
      </div>
      <div style={{ background: '#065F46', color: '#fff', borderRadius: 12, padding: '14px 20px', minWidth: 200 }}>
        <div style={{ fontSize: 13, opacity: 0.9 }}>{t('pending_net_amount', { defaultValue: 'Neto a dispersar' })}</div>
        <div style={{ fontSize: 26, fontWeight: 700 }}>{symbolize(pendingNet)}</div>
      </div>
    </div>
    <MaterialTable
      title={t('Withdraw_title')}
      columns={columns}
      style={{
        direction: isRTL === "rtl" ? "rtl" : "ltr",
        borderRadius: "8px",
        boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
        padding: "20px",
      }}
      data={data}
      options={{
        selection: true,
        exportCsv: (columns, data) => {
          let hArray = [];
          const headerRow = columns.map(col => {
            if (typeof col.title === 'object') {
              return col.title.props.text;
            }
            hArray.push(col.field);
            return col.title;
          });
          const dataRows = data.map(({ tableData, ...row }) => {
            row.date = new Date(row.date).toLocaleDateString() + ' '+ new Date(row.date).toLocaleTimeString()
            row.processDate = row.processDate? new Date(row.processDate).toLocaleDateString() + ' '+ new Date(row.processDate).toLocaleTimeString(): ''
            const fees = resolveWithdrawRowFees(row, settings);
            row.gmf = fees.gmf;
            row.disbursementFee = fees.disbursementFee;
            row.gatewayFee = fees.gatewayFee;
            row.totalFees = fees.totalFees;
            row.netAmount = fees.net;
            let dArr = [];
            for(let i=0;i< hArray.length; i++) {
              dArr.push(row[hArray[i]]);
            }
            return Object.values(dArr);
          })
          const { exportDelimiter } = ",";
          const delimiter = exportDelimiter ? exportDelimiter : ",";
          const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
          const csvFileName = 'download.csv';
          downloadCsv(csvContent, csvFileName);
        },
        exportButton: {
          csv: settings.AllowCriticalEditsAdmin,
          pdf: false,
        },
        rowStyle: (rowData) => ({
          backgroundColor:
            statusOf(rowData) === 'paid' ? '#F3FBF6'
            : statusOf(rowData) === 'rejected' ? '#FCEFEF'
            : colors.WHITE
        }),
        ...TableStyle(settings)
      }}
      localization={localization(t)}
      actions={[
        {
          icon: 'picture_as_pdf',
          tooltip: t('generate_payment_pdf', { defaultValue: 'Generar orden de pago (PDF)' }),
          position: 'toolbarOnSelect',
          onClick: (event, rows) => exportSelectedPDF(rows)
        },
        {
          icon: 'account_balance',
          tooltip: t('generate_bank_file', { defaultValue: 'Generar archivo de dispersión (banco)' }),
          position: 'toolbarOnSelect',
          onClick: (event, rows) => exportSelectedBankFile(rows)
        },
        {
          icon: 'done_all',
          tooltip: t('mark_paid', { defaultValue: 'Marcar como pagados' }),
          position: 'toolbarOnSelect',
          onClick: (event, rows) => markSelectedPaid(rows)
        },
        rowData => ({
          icon: 'check',
          tooltip: t('process_withdraw'),
          disabled: statusOf(rowData) !== 'pending' || !settings.AllowCriticalEditsAdmin,
          onClick: (event, rowData) => {
            if (!settings.AllowCriticalEditsAdmin) { alert(t('demo_mode')); return; }
            if (window.confirm(t('confirm_mark_paid', { defaultValue: '¿Marcar como pagado este retiro?' }))) {
              dispatch(completeWithdraw(rowData)).catch((err) => {
                console.error('completeWithdraw failed', err);
                alert(t('process_failed', { defaultValue: 'No se pudo procesar. Verifica tu sesión de admin e intenta de nuevo.' }));
              });
            }
          }
        }),
        rowData => ({
          icon: 'close',
          tooltip: t('reject_withdraw', { defaultValue: 'Rechazar y devolver saldo' }),
          disabled: statusOf(rowData) !== 'pending' || !settings.AllowCriticalEditsAdmin,
          onClick: (event, rowData) => {
            if (!settings.AllowCriticalEditsAdmin) { alert(t('demo_mode')); return; }
            if (window.confirm(t('confirm_reject_withdraw', { defaultValue: '¿Rechazar el retiro y devolver el saldo al usuario?' }))) {
              dispatch(rejectWithdraw(rowData)).catch((err) => {
                console.error('rejectWithdraw failed', err);
                alert(t('process_failed', { defaultValue: 'No se pudo procesar. Verifica tu sesión de admin e intenta de nuevo.' }));
              });
            }
          }
        }),
      ]}
    />
    </ThemeProvider>
  );
}

export default Withdraws;
